// Extracted from docs/R&S-Takeoffsheet.xlsx, sheet 'SEWER RATES' (columns B=Pipe Dia,
// C=Trench Depth, K=Disposal Arisings (m3/m), N=Backfill (m3/m)). These are fixed
// volume-per-metre lookup values (not £ rates) used by the Foul/Storm Summary
// sheet's Surplus/Backfill columns — see foulSummaryUtils.ts buildFoulSurplusBackfillData.
// Do not hand-edit; regenerate from the source workbook if the rates change.

export interface SewerRateEntry {
  pipeDiameter: number; // mm
  trenchDepth: number; // m (depth category, 0.25m increments)
  disposalArisings: number; // m3/m — disposal / arisings volume per metre of trench
  backfill: number; // m3/m — backfill volume per metre of trench
}

export const SEWER_RATES: SewerRateEntry[] = [
  { pipeDiameter: 100, trenchDepth: 1, disposalArisings: 0.66, backfill: 0.27 },
  { pipeDiameter: 100, trenchDepth: 1.25, disposalArisings: 0.9, backfill: 0.5 },
  { pipeDiameter: 100, trenchDepth: 1.5, disposalArisings: 1.13, backfill: 0.73 },
  { pipeDiameter: 100, trenchDepth: 1.75, disposalArisings: 1.36, backfill: 0.96 },
  { pipeDiameter: 100, trenchDepth: 2, disposalArisings: 1.59, backfill: 1.2 },
  { pipeDiameter: 100, trenchDepth: 2.25, disposalArisings: 1.83, backfill: 1.43 },
  { pipeDiameter: 100, trenchDepth: 2.5, disposalArisings: 2.66, backfill: 2.14 },
  { pipeDiameter: 100, trenchDepth: 2.75, disposalArisings: 2.96, backfill: 2.44 },
  { pipeDiameter: 100, trenchDepth: 3, disposalArisings: 3.26, backfill: 2.74 },
  { pipeDiameter: 100, trenchDepth: 3.25, disposalArisings: 3.56, backfill: 3.04 },
  { pipeDiameter: 100, trenchDepth: 3.5, disposalArisings: 3.86, backfill: 3.34 },
  { pipeDiameter: 100, trenchDepth: 3.75, disposalArisings: 4.16, backfill: 3.64 },
  { pipeDiameter: 100, trenchDepth: 4, disposalArisings: 4.46, backfill: 3.94 },
  { pipeDiameter: 100, trenchDepth: 4.25, disposalArisings: 4.76, backfill: 4.24 },
  { pipeDiameter: 100, trenchDepth: 4.5, disposalArisings: 5.06, backfill: 4.54 },
  { pipeDiameter: 100, trenchDepth: 4.75, disposalArisings: 5.36, backfill: 4.84 },
  { pipeDiameter: 100, trenchDepth: 5, disposalArisings: 5.66, backfill: 5.14 },
  { pipeDiameter: 100, trenchDepth: 5.25, disposalArisings: 5.96, backfill: 5.44 },
  { pipeDiameter: 100, trenchDepth: 5.5, disposalArisings: 6.26, backfill: 5.74 },
  { pipeDiameter: 100, trenchDepth: 5.75, disposalArisings: 6.56, backfill: 6.04 },
  { pipeDiameter: 100, trenchDepth: 6, disposalArisings: 6.86, backfill: 6.34 },
  { pipeDiameter: 150, trenchDepth: 1, disposalArisings: 0.7, backfill: 0.23 },
  { pipeDiameter: 150, trenchDepth: 1.25, disposalArisings: 0.95, backfill: 0.48 },
  { pipeDiameter: 150, trenchDepth: 1.5, disposalArisings: 1.19, backfill: 0.72 },
  { pipeDiameter: 150, trenchDepth: 1.75, disposalArisings: 1.44, backfill: 0.97 },
  { pipeDiameter: 150, trenchDepth: 2, disposalArisings: 1.68, backfill: 1.21 },
  { pipeDiameter: 150, trenchDepth: 2.25, disposalArisings: 1.93, backfill: 1.46 },
  { pipeDiameter: 150, trenchDepth: 2.5, disposalArisings: 2.66, backfill: 2.08 },
  { pipeDiameter: 150, trenchDepth: 2.75, disposalArisings: 2.96, backfill: 2.38 },
  { pipeDiameter: 150, trenchDepth: 3, disposalArisings: 3.26, backfill: 2.68 },
  { pipeDiameter: 150, trenchDepth: 3.25, disposalArisings: 3.56, backfill: 2.98 },
  { pipeDiameter: 150, trenchDepth: 3.5, disposalArisings: 3.86, backfill: 3.28 },
  { pipeDiameter: 150, trenchDepth: 3.75, disposalArisings: 4.16, backfill: 3.58 },
  { pipeDiameter: 150, trenchDepth: 4, disposalArisings: 4.46, backfill: 3.88 },
  { pipeDiameter: 150, trenchDepth: 4.25, disposalArisings: 4.76, backfill: 4.18 },
  { pipeDiameter: 150, trenchDepth: 4.5, disposalArisings: 5.06, backfill: 4.48 },
  { pipeDiameter: 150, trenchDepth: 4.75, disposalArisings: 5.36, backfill: 4.78 },
  { pipeDiameter: 150, trenchDepth: 5, disposalArisings: 5.66, backfill: 5.08 },
  { pipeDiameter: 150, trenchDepth: 5.25, disposalArisings: 5.96, backfill: 5.38 },
  { pipeDiameter: 150, trenchDepth: 5.5, disposalArisings: 6.26, backfill: 5.68 },
  { pipeDiameter: 150, trenchDepth: 5.75, disposalArisings: 6.56, backfill: 5.98 },
  { pipeDiameter: 150, trenchDepth: 6, disposalArisings: 6.86, backfill: 6.28 },
  { pipeDiameter: 225, trenchDepth: 1, disposalArisings: 0.76, backfill: 0.17 },
  { pipeDiameter: 225, trenchDepth: 1.25, disposalArisings: 1.02, backfill: 0.43 },
  { pipeDiameter: 225, trenchDepth: 1.5, disposalArisings: 1.29, backfill: 0.7 },
  { pipeDiameter: 225, trenchDepth: 1.75, disposalArisings: 1.55, backfill: 0.96 },
  { pipeDiameter: 225, trenchDepth: 2, disposalArisings: 1.82, backfill: 1.23 },
  { pipeDiameter: 225, trenchDepth: 2.25, disposalArisings: 2.08, backfill: 1.49 },
  { pipeDiameter: 225, trenchDepth: 2.5, disposalArisings: 2.66, backfill: 1.99 },
  { pipeDiameter: 225, trenchDepth: 2.75, disposalArisings: 2.96, backfill: 2.29 },
  { pipeDiameter: 225, trenchDepth: 3, disposalArisings: 3.26, backfill: 2.59 },
  { pipeDiameter: 225, trenchDepth: 3.25, disposalArisings: 3.56, backfill: 2.89 },
  { pipeDiameter: 225, trenchDepth: 3.5, disposalArisings: 3.86, backfill: 3.19 },
  { pipeDiameter: 225, trenchDepth: 3.75, disposalArisings: 4.16, backfill: 3.49 },
  { pipeDiameter: 225, trenchDepth: 4, disposalArisings: 4.46, backfill: 3.79 },
  { pipeDiameter: 225, trenchDepth: 4.25, disposalArisings: 4.76, backfill: 4.09 },
  { pipeDiameter: 225, trenchDepth: 4.5, disposalArisings: 5.06, backfill: 4.39 },
  { pipeDiameter: 225, trenchDepth: 4.75, disposalArisings: 5.36, backfill: 4.69 },
  { pipeDiameter: 225, trenchDepth: 5, disposalArisings: 5.66, backfill: 4.99 },
  { pipeDiameter: 225, trenchDepth: 5.25, disposalArisings: 5.96, backfill: 5.29 },
  { pipeDiameter: 225, trenchDepth: 5.5, disposalArisings: 6.26, backfill: 5.59 },
  { pipeDiameter: 225, trenchDepth: 5.75, disposalArisings: 6.56, backfill: 5.89 },
  { pipeDiameter: 225, trenchDepth: 6, disposalArisings: 6.86, backfill: 6.19 },
  { pipeDiameter: 300, trenchDepth: 1, disposalArisings: 0.92, backfill: 0.05 },
  { pipeDiameter: 300, trenchDepth: 1.25, disposalArisings: 1.23, backfill: 0.36 },
  { pipeDiameter: 300, trenchDepth: 1.5, disposalArisings: 1.53, backfill: 0.66 },
  { pipeDiameter: 300, trenchDepth: 1.75, disposalArisings: 1.84, backfill: 0.97 },
  { pipeDiameter: 300, trenchDepth: 2, disposalArisings: 2.14, backfill: 1.27 },
  { pipeDiameter: 300, trenchDepth: 2.25, disposalArisings: 2.45, backfill: 1.58 },
  { pipeDiameter: 300, trenchDepth: 2.5, disposalArisings: 2.75, backfill: 1.88 },
  { pipeDiameter: 300, trenchDepth: 2.75, disposalArisings: 3.06, backfill: 2.19 },
  { pipeDiameter: 300, trenchDepth: 3, disposalArisings: 3.36, backfill: 2.49 },
  { pipeDiameter: 300, trenchDepth: 3.25, disposalArisings: 3.67, backfill: 2.8 },
  { pipeDiameter: 300, trenchDepth: 3.5, disposalArisings: 3.97, backfill: 3.1 },
  { pipeDiameter: 300, trenchDepth: 3.75, disposalArisings: 4.28, backfill: 3.41 },
  { pipeDiameter: 300, trenchDepth: 4, disposalArisings: 4.58, backfill: 3.71 },
  { pipeDiameter: 300, trenchDepth: 4.25, disposalArisings: 4.89, backfill: 4.02 },
  { pipeDiameter: 300, trenchDepth: 4.5, disposalArisings: 5.19, backfill: 4.32 },
  { pipeDiameter: 300, trenchDepth: 4.75, disposalArisings: 5.5, backfill: 4.63 },
  { pipeDiameter: 300, trenchDepth: 5, disposalArisings: 5.8, backfill: 4.93 },
  { pipeDiameter: 300, trenchDepth: 5.25, disposalArisings: 6.11, backfill: 5.24 },
  { pipeDiameter: 300, trenchDepth: 5.5, disposalArisings: 6.41, backfill: 5.54 },
  { pipeDiameter: 300, trenchDepth: 5.75, disposalArisings: 6.72, backfill: 5.85 },
  { pipeDiameter: 300, trenchDepth: 6, disposalArisings: 7.02, backfill: 6.15 },
  { pipeDiameter: 375, trenchDepth: 1, disposalArisings: 1, backfill: 0 },
  { pipeDiameter: 375, trenchDepth: 1.25, disposalArisings: 1.33, backfill: 0.28 },
  { pipeDiameter: 375, trenchDepth: 1.5, disposalArisings: 1.66, backfill: 0.6 },
  { pipeDiameter: 375, trenchDepth: 1.75, disposalArisings: 1.98, backfill: 0.93 },
  { pipeDiameter: 375, trenchDepth: 2, disposalArisings: 2.31, backfill: 1.26 },
  { pipeDiameter: 375, trenchDepth: 2.25, disposalArisings: 2.64, backfill: 1.59 },
  { pipeDiameter: 375, trenchDepth: 2.5, disposalArisings: 2.97, backfill: 1.91 },
  { pipeDiameter: 375, trenchDepth: 2.75, disposalArisings: 3.29, backfill: 2.24 },
  { pipeDiameter: 375, trenchDepth: 3, disposalArisings: 3.62, backfill: 2.57 },
  { pipeDiameter: 375, trenchDepth: 3.25, disposalArisings: 3.95, backfill: 2.9 },
  { pipeDiameter: 375, trenchDepth: 3.5, disposalArisings: 4.28, backfill: 3.22 },
  { pipeDiameter: 375, trenchDepth: 3.75, disposalArisings: 4.6, backfill: 3.55 },
  { pipeDiameter: 375, trenchDepth: 4, disposalArisings: 4.93, backfill: 3.88 },
  { pipeDiameter: 375, trenchDepth: 4.25, disposalArisings: 5.26, backfill: 4.21 },
  { pipeDiameter: 375, trenchDepth: 4.5, disposalArisings: 5.59, backfill: 4.53 },
  { pipeDiameter: 375, trenchDepth: 4.75, disposalArisings: 5.91, backfill: 4.86 },
  { pipeDiameter: 375, trenchDepth: 5, disposalArisings: 6.24, backfill: 5.19 },
  { pipeDiameter: 375, trenchDepth: 5.25, disposalArisings: 6.57, backfill: 5.52 },
  { pipeDiameter: 375, trenchDepth: 5.5, disposalArisings: 6.9, backfill: 5.84 },
  { pipeDiameter: 375, trenchDepth: 5.75, disposalArisings: 7.22, backfill: 6.17 },
  { pipeDiameter: 375, trenchDepth: 6, disposalArisings: 7.55, backfill: 6.5 },
  { pipeDiameter: 450, trenchDepth: 1, disposalArisings: 1.07, backfill: 0 },
  { pipeDiameter: 450, trenchDepth: 1.25, disposalArisings: 1.42, backfill: 0.18 },
  { pipeDiameter: 450, trenchDepth: 1.5, disposalArisings: 1.76, backfill: 0.53 },
  { pipeDiameter: 450, trenchDepth: 1.75, disposalArisings: 2.11, backfill: 0.88 },
  { pipeDiameter: 450, trenchDepth: 2, disposalArisings: 2.46, backfill: 1.23 },
  { pipeDiameter: 450, trenchDepth: 2.25, disposalArisings: 2.81, backfill: 1.57 },
  { pipeDiameter: 450, trenchDepth: 2.5, disposalArisings: 3.15, backfill: 1.92 },
  { pipeDiameter: 450, trenchDepth: 2.75, disposalArisings: 3.5, backfill: 2.27 },
  { pipeDiameter: 450, trenchDepth: 3, disposalArisings: 3.85, backfill: 2.62 },
  { pipeDiameter: 450, trenchDepth: 3.25, disposalArisings: 4.2, backfill: 2.96 },
  { pipeDiameter: 450, trenchDepth: 3.5, disposalArisings: 4.54, backfill: 3.31 },
  { pipeDiameter: 450, trenchDepth: 3.75, disposalArisings: 4.89, backfill: 3.66 },
  { pipeDiameter: 450, trenchDepth: 4, disposalArisings: 5.24, backfill: 4.01 },
  { pipeDiameter: 450, trenchDepth: 4.25, disposalArisings: 5.59, backfill: 4.35 },
  { pipeDiameter: 450, trenchDepth: 4.5, disposalArisings: 5.93, backfill: 4.7 },
  { pipeDiameter: 450, trenchDepth: 4.75, disposalArisings: 6.28, backfill: 5.05 },
  { pipeDiameter: 450, trenchDepth: 5, disposalArisings: 6.63, backfill: 5.4 },
  { pipeDiameter: 450, trenchDepth: 5.25, disposalArisings: 6.98, backfill: 5.74 },
  { pipeDiameter: 450, trenchDepth: 5.5, disposalArisings: 7.32, backfill: 6.09 },
  { pipeDiameter: 450, trenchDepth: 5.75, disposalArisings: 7.67, backfill: 6.44 },
  { pipeDiameter: 450, trenchDepth: 6, disposalArisings: 8.02, backfill: 6.79 },
  { pipeDiameter: 525, trenchDepth: 1, disposalArisings: 1.16, backfill: 0 },
  { pipeDiameter: 525, trenchDepth: 1.25, disposalArisings: 1.53, backfill: 0.07 },
  { pipeDiameter: 525, trenchDepth: 1.5, disposalArisings: 1.91, backfill: 0.44 },
  { pipeDiameter: 525, trenchDepth: 1.75, disposalArisings: 2.28, backfill: 0.81 },
  { pipeDiameter: 525, trenchDepth: 2, disposalArisings: 2.65, backfill: 1.18 },
  { pipeDiameter: 525, trenchDepth: 2.25, disposalArisings: 3.02, backfill: 1.56 },
  { pipeDiameter: 525, trenchDepth: 2.5, disposalArisings: 3.4, backfill: 1.93 },
  { pipeDiameter: 525, trenchDepth: 2.75, disposalArisings: 3.77, backfill: 2.3 },
  { pipeDiameter: 525, trenchDepth: 3, disposalArisings: 4.14, backfill: 2.67 },
  { pipeDiameter: 525, trenchDepth: 3.25, disposalArisings: 4.51, backfill: 3.05 },
  { pipeDiameter: 525, trenchDepth: 3.5, disposalArisings: 4.89, backfill: 3.42 },
  { pipeDiameter: 525, trenchDepth: 3.75, disposalArisings: 5.26, backfill: 3.79 },
  { pipeDiameter: 525, trenchDepth: 4, disposalArisings: 5.63, backfill: 4.16 },
  { pipeDiameter: 525, trenchDepth: 4.25, disposalArisings: 6, backfill: 4.54 },
  { pipeDiameter: 525, trenchDepth: 4.5, disposalArisings: 6.38, backfill: 4.91 },
  { pipeDiameter: 525, trenchDepth: 4.75, disposalArisings: 6.75, backfill: 5.28 },
  { pipeDiameter: 525, trenchDepth: 5, disposalArisings: 7.12, backfill: 5.65 },
  { pipeDiameter: 525, trenchDepth: 5.25, disposalArisings: 7.49, backfill: 6.03 },
  { pipeDiameter: 525, trenchDepth: 5.5, disposalArisings: 7.87, backfill: 6.4 },
  { pipeDiameter: 525, trenchDepth: 5.75, disposalArisings: 8.24, backfill: 6.77 },
  { pipeDiameter: 525, trenchDepth: 6, disposalArisings: 8.61, backfill: 7.14 },
  { pipeDiameter: 600, trenchDepth: 1, disposalArisings: 1.26, backfill: 0 },
  { pipeDiameter: 600, trenchDepth: 1.25, disposalArisings: 1.66, backfill: 0 },
  { pipeDiameter: 600, trenchDepth: 1.5, disposalArisings: 2.06, backfill: 0.33 },
  { pipeDiameter: 600, trenchDepth: 1.75, disposalArisings: 2.46, backfill: 0.72 },
  { pipeDiameter: 600, trenchDepth: 2, disposalArisings: 2.85, backfill: 1.12 },
  { pipeDiameter: 600, trenchDepth: 2.25, disposalArisings: 3.25, backfill: 1.52 },
  { pipeDiameter: 600, trenchDepth: 2.5, disposalArisings: 3.65, backfill: 1.92 },
  { pipeDiameter: 600, trenchDepth: 2.75, disposalArisings: 4.05, backfill: 2.31 },
  { pipeDiameter: 600, trenchDepth: 3, disposalArisings: 4.44, backfill: 2.71 },
  { pipeDiameter: 600, trenchDepth: 3.25, disposalArisings: 4.84, backfill: 3.11 },
  { pipeDiameter: 600, trenchDepth: 3.5, disposalArisings: 5.24, backfill: 3.51 },
  { pipeDiameter: 600, trenchDepth: 3.75, disposalArisings: 5.64, backfill: 3.9 },
  { pipeDiameter: 600, trenchDepth: 4, disposalArisings: 6.03, backfill: 4.3 },
  { pipeDiameter: 600, trenchDepth: 4.25, disposalArisings: 6.43, backfill: 4.7 },
  { pipeDiameter: 600, trenchDepth: 4.5, disposalArisings: 6.83, backfill: 5.1 },
  { pipeDiameter: 600, trenchDepth: 4.75, disposalArisings: 7.23, backfill: 5.49 },
  { pipeDiameter: 600, trenchDepth: 5, disposalArisings: 7.62, backfill: 5.89 },
  { pipeDiameter: 600, trenchDepth: 5.25, disposalArisings: 8.02, backfill: 6.29 },
  { pipeDiameter: 600, trenchDepth: 5.5, disposalArisings: 8.42, backfill: 6.69 },
  { pipeDiameter: 600, trenchDepth: 5.75, disposalArisings: 8.82, backfill: 7.08 },
  { pipeDiameter: 600, trenchDepth: 6, disposalArisings: 9.21, backfill: 7.48 },
  { pipeDiameter: 675, trenchDepth: 1, disposalArisings: 1.36, backfill: 0 },
  { pipeDiameter: 675, trenchDepth: 1.25, disposalArisings: 1.78, backfill: 0 },
  { pipeDiameter: 675, trenchDepth: 1.5, disposalArisings: 2.21, backfill: 0.2 },
  { pipeDiameter: 675, trenchDepth: 1.75, disposalArisings: 2.63, backfill: 0.63 },
  { pipeDiameter: 675, trenchDepth: 2, disposalArisings: 3.05, backfill: 1.05 },
  { pipeDiameter: 675, trenchDepth: 2.25, disposalArisings: 3.47, backfill: 1.47 },
  { pipeDiameter: 675, trenchDepth: 2.5, disposalArisings: 3.9, backfill: 1.89 },
  { pipeDiameter: 675, trenchDepth: 2.75, disposalArisings: 4.32, backfill: 2.32 },
  { pipeDiameter: 675, trenchDepth: 3, disposalArisings: 4.74, backfill: 2.74 },
  { pipeDiameter: 675, trenchDepth: 3.25, disposalArisings: 5.16, backfill: 3.16 },
  { pipeDiameter: 675, trenchDepth: 3.5, disposalArisings: 5.59, backfill: 3.58 },
  { pipeDiameter: 675, trenchDepth: 3.75, disposalArisings: 6.01, backfill: 4.01 },
  { pipeDiameter: 675, trenchDepth: 4, disposalArisings: 6.43, backfill: 4.43 },
  { pipeDiameter: 675, trenchDepth: 4.25, disposalArisings: 6.85, backfill: 4.85 },
  { pipeDiameter: 675, trenchDepth: 4.5, disposalArisings: 7.28, backfill: 5.27 },
  { pipeDiameter: 675, trenchDepth: 4.75, disposalArisings: 7.7, backfill: 5.7 },
  { pipeDiameter: 675, trenchDepth: 5, disposalArisings: 8.12, backfill: 6.12 },
  { pipeDiameter: 675, trenchDepth: 5.25, disposalArisings: 8.54, backfill: 6.54 },
  { pipeDiameter: 675, trenchDepth: 5.5, disposalArisings: 8.97, backfill: 6.96 },
  { pipeDiameter: 675, trenchDepth: 5.75, disposalArisings: 9.39, backfill: 7.39 },
  { pipeDiameter: 675, trenchDepth: 6, disposalArisings: 9.81, backfill: 7.81 },
  { pipeDiameter: 750, trenchDepth: 1, disposalArisings: 1.48, backfill: 0 },
  { pipeDiameter: 750, trenchDepth: 1.25, disposalArisings: 1.93, backfill: 0 },
  { pipeDiameter: 750, trenchDepth: 1.5, disposalArisings: 2.38, backfill: 0.05 },
  { pipeDiameter: 750, trenchDepth: 1.75, disposalArisings: 2.83, backfill: 0.5 },
  { pipeDiameter: 750, trenchDepth: 2, disposalArisings: 3.28, backfill: 0.95 },
  { pipeDiameter: 750, trenchDepth: 2.25, disposalArisings: 3.73, backfill: 1.4 },
  { pipeDiameter: 750, trenchDepth: 2.5, disposalArisings: 4.18, backfill: 1.85 },
  { pipeDiameter: 750, trenchDepth: 2.75, disposalArisings: 4.63, backfill: 2.3 },
  { pipeDiameter: 750, trenchDepth: 3, disposalArisings: 5.08, backfill: 2.75 },
  { pipeDiameter: 750, trenchDepth: 3.25, disposalArisings: 5.53, backfill: 3.2 },
  { pipeDiameter: 750, trenchDepth: 3.5, disposalArisings: 5.98, backfill: 3.65 },
  { pipeDiameter: 750, trenchDepth: 3.75, disposalArisings: 6.43, backfill: 4.1 },
  { pipeDiameter: 750, trenchDepth: 4, disposalArisings: 6.88, backfill: 4.55 },
  { pipeDiameter: 750, trenchDepth: 4.25, disposalArisings: 7.33, backfill: 5 },
  { pipeDiameter: 750, trenchDepth: 4.5, disposalArisings: 7.78, backfill: 5.45 },
  { pipeDiameter: 750, trenchDepth: 4.75, disposalArisings: 8.23, backfill: 5.9 },
  { pipeDiameter: 750, trenchDepth: 5, disposalArisings: 8.68, backfill: 6.35 },
  { pipeDiameter: 750, trenchDepth: 5.25, disposalArisings: 9.13, backfill: 6.8 },
  { pipeDiameter: 750, trenchDepth: 5.5, disposalArisings: 9.58, backfill: 7.25 },
  { pipeDiameter: 750, trenchDepth: 5.75, disposalArisings: 10.03, backfill: 7.7 },
  { pipeDiameter: 750, trenchDepth: 6, disposalArisings: 10.48, backfill: 8.15 },
  { pipeDiameter: 825, trenchDepth: 1, disposalArisings: 1.47, backfill: 0 },
  { pipeDiameter: 825, trenchDepth: 1.25, disposalArisings: 1.94, backfill: 0 },
  { pipeDiameter: 825, trenchDepth: 1.5, disposalArisings: 2.41, backfill: 0 },
  { pipeDiameter: 825, trenchDepth: 1.75, disposalArisings: 2.88, backfill: 0.46 },
  { pipeDiameter: 825, trenchDepth: 2, disposalArisings: 3.35, backfill: 0.93 },
  { pipeDiameter: 825, trenchDepth: 2.25, disposalArisings: 3.82, backfill: 1.4 },
  { pipeDiameter: 825, trenchDepth: 2.5, disposalArisings: 4.29, backfill: 1.87 },
  { pipeDiameter: 825, trenchDepth: 2.75, disposalArisings: 4.76, backfill: 2.34 },
  { pipeDiameter: 825, trenchDepth: 3, disposalArisings: 5.23, backfill: 2.81 },
  { pipeDiameter: 825, trenchDepth: 3.25, disposalArisings: 5.7, backfill: 3.28 },
  { pipeDiameter: 825, trenchDepth: 3.5, disposalArisings: 6.17, backfill: 3.75 },
  { pipeDiameter: 825, trenchDepth: 3.75, disposalArisings: 6.64, backfill: 4.22 },
  { pipeDiameter: 825, trenchDepth: 4, disposalArisings: 7.11, backfill: 4.69 },
  { pipeDiameter: 825, trenchDepth: 4.25, disposalArisings: 7.58, backfill: 5.16 },
  { pipeDiameter: 825, trenchDepth: 4.5, disposalArisings: 8.05, backfill: 5.63 },
  { pipeDiameter: 825, trenchDepth: 4.75, disposalArisings: 8.52, backfill: 6.1 },
  { pipeDiameter: 825, trenchDepth: 5, disposalArisings: 8.99, backfill: 6.57 },
  { pipeDiameter: 825, trenchDepth: 5.25, disposalArisings: 9.46, backfill: 7.04 },
  { pipeDiameter: 825, trenchDepth: 5.5, disposalArisings: 9.93, backfill: 7.51 },
  { pipeDiameter: 825, trenchDepth: 5.75, disposalArisings: 10.4, backfill: 7.98 },
  { pipeDiameter: 825, trenchDepth: 6, disposalArisings: 10.87, backfill: 8.45 },
  { pipeDiameter: 900, trenchDepth: 1, disposalArisings: 1.49, backfill: 0 },
  { pipeDiameter: 900, trenchDepth: 1.25, disposalArisings: 1.96, backfill: 0 },
  { pipeDiameter: 900, trenchDepth: 1.5, disposalArisings: 2.43, backfill: 0 },
  { pipeDiameter: 900, trenchDepth: 1.75, disposalArisings: 2.9, backfill: 0.3 },
  { pipeDiameter: 900, trenchDepth: 2, disposalArisings: 3.37, backfill: 0.77 },
  { pipeDiameter: 900, trenchDepth: 2.25, disposalArisings: 3.84, backfill: 1.24 },
  { pipeDiameter: 900, trenchDepth: 2.5, disposalArisings: 4.31, backfill: 1.71 },
  { pipeDiameter: 900, trenchDepth: 2.75, disposalArisings: 4.78, backfill: 2.18 },
  { pipeDiameter: 900, trenchDepth: 3, disposalArisings: 5.25, backfill: 2.65 },
  { pipeDiameter: 900, trenchDepth: 3.25, disposalArisings: 5.72, backfill: 3.12 },
  { pipeDiameter: 900, trenchDepth: 3.5, disposalArisings: 6.19, backfill: 3.59 },
  { pipeDiameter: 900, trenchDepth: 3.75, disposalArisings: 6.66, backfill: 4.06 },
  { pipeDiameter: 900, trenchDepth: 4, disposalArisings: 7.13, backfill: 4.53 },
  { pipeDiameter: 900, trenchDepth: 4.25, disposalArisings: 7.6, backfill: 5 },
  { pipeDiameter: 900, trenchDepth: 4.5, disposalArisings: 8.07, backfill: 5.47 },
  { pipeDiameter: 900, trenchDepth: 4.75, disposalArisings: 8.54, backfill: 5.94 },
  { pipeDiameter: 900, trenchDepth: 5, disposalArisings: 9.01, backfill: 6.41 },
  { pipeDiameter: 900, trenchDepth: 5.25, disposalArisings: 9.48, backfill: 6.88 },
  { pipeDiameter: 900, trenchDepth: 5.5, disposalArisings: 9.95, backfill: 7.35 },
  { pipeDiameter: 900, trenchDepth: 5.75, disposalArisings: 10.42, backfill: 7.82 },
  { pipeDiameter: 900, trenchDepth: 6, disposalArisings: 10.89, backfill: 8.29 },
  { pipeDiameter: 1050, trenchDepth: 1, disposalArisings: 1.67, backfill: 0 },
  { pipeDiameter: 1050, trenchDepth: 1.25, disposalArisings: 2.19, backfill: 0 },
  { pipeDiameter: 1050, trenchDepth: 1.5, disposalArisings: 2.71, backfill: 0 },
  { pipeDiameter: 1050, trenchDepth: 1.75, disposalArisings: 3.23, backfill: 0 },
  { pipeDiameter: 1050, trenchDepth: 2, disposalArisings: 3.74, backfill: 0.5 },
  { pipeDiameter: 1050, trenchDepth: 2.25, disposalArisings: 4.26, backfill: 1.02 },
  { pipeDiameter: 1050, trenchDepth: 2.5, disposalArisings: 4.78, backfill: 1.54 },
  { pipeDiameter: 1050, trenchDepth: 2.75, disposalArisings: 5.3, backfill: 2.05 },
  { pipeDiameter: 1050, trenchDepth: 3, disposalArisings: 5.81, backfill: 2.57 },
  { pipeDiameter: 1050, trenchDepth: 3.25, disposalArisings: 6.33, backfill: 3.09 },
  { pipeDiameter: 1050, trenchDepth: 3.5, disposalArisings: 6.85, backfill: 3.61 },
  { pipeDiameter: 1050, trenchDepth: 3.75, disposalArisings: 7.37, backfill: 4.12 },
  { pipeDiameter: 1050, trenchDepth: 4, disposalArisings: 7.88, backfill: 4.64 },
  { pipeDiameter: 1050, trenchDepth: 4.25, disposalArisings: 8.4, backfill: 5.16 },
  { pipeDiameter: 1050, trenchDepth: 4.5, disposalArisings: 8.92, backfill: 5.68 },
  { pipeDiameter: 1050, trenchDepth: 4.75, disposalArisings: 9.44, backfill: 6.19 },
  { pipeDiameter: 1050, trenchDepth: 5, disposalArisings: 9.95, backfill: 6.71 },
  { pipeDiameter: 1050, trenchDepth: 5.25, disposalArisings: 10.47, backfill: 7.23 },
  { pipeDiameter: 1050, trenchDepth: 5.5, disposalArisings: 10.99, backfill: 7.75 },
  { pipeDiameter: 1050, trenchDepth: 5.75, disposalArisings: 11.51, backfill: 8.26 },
  { pipeDiameter: 1050, trenchDepth: 6, disposalArisings: 12.02, backfill: 8.78 },
  { pipeDiameter: 1200, trenchDepth: 1, disposalArisings: 1.88, backfill: 0 },
  { pipeDiameter: 1200, trenchDepth: 1.25, disposalArisings: 2.44, backfill: 0 },
  { pipeDiameter: 1200, trenchDepth: 1.5, disposalArisings: 3.01, backfill: 0 },
  { pipeDiameter: 1200, trenchDepth: 1.75, disposalArisings: 3.57, backfill: 0 },
  { pipeDiameter: 1200, trenchDepth: 2, disposalArisings: 4.14, backfill: 0.16 },
  { pipeDiameter: 1200, trenchDepth: 2.25, disposalArisings: 4.7, backfill: 0.72 },
  { pipeDiameter: 1200, trenchDepth: 2.5, disposalArisings: 5.27, backfill: 1.29 },
  { pipeDiameter: 1200, trenchDepth: 2.75, disposalArisings: 5.83, backfill: 1.85 },
  { pipeDiameter: 1200, trenchDepth: 3, disposalArisings: 6.4, backfill: 2.42 },
  { pipeDiameter: 1200, trenchDepth: 3.25, disposalArisings: 6.96, backfill: 2.98 },
  { pipeDiameter: 1200, trenchDepth: 3.5, disposalArisings: 7.53, backfill: 3.55 },
  { pipeDiameter: 1200, trenchDepth: 3.75, disposalArisings: 8.09, backfill: 4.11 },
  { pipeDiameter: 1200, trenchDepth: 4, disposalArisings: 8.66, backfill: 4.68 },
  { pipeDiameter: 1200, trenchDepth: 4.25, disposalArisings: 9.22, backfill: 5.24 },
  { pipeDiameter: 1200, trenchDepth: 4.5, disposalArisings: 9.79, backfill: 5.81 },
  { pipeDiameter: 1200, trenchDepth: 4.75, disposalArisings: 10.35, backfill: 6.37 },
  { pipeDiameter: 1200, trenchDepth: 5, disposalArisings: 10.92, backfill: 6.94 },
  { pipeDiameter: 1200, trenchDepth: 5.25, disposalArisings: 11.48, backfill: 7.5 },
  { pipeDiameter: 1200, trenchDepth: 5.5, disposalArisings: 12.05, backfill: 8.07 },
  { pipeDiameter: 1200, trenchDepth: 5.75, disposalArisings: 12.61, backfill: 8.63 },
  { pipeDiameter: 1200, trenchDepth: 6, disposalArisings: 13.18, backfill: 9.2 },
  { pipeDiameter: 1350, trenchDepth: 1, disposalArisings: 2.01, backfill: 0 },
  { pipeDiameter: 1350, trenchDepth: 1.25, disposalArisings: 2.61, backfill: 0 },
  { pipeDiameter: 1350, trenchDepth: 1.5, disposalArisings: 3.22, backfill: 0 },
  { pipeDiameter: 1350, trenchDepth: 1.75, disposalArisings: 3.82, backfill: 0 },
  { pipeDiameter: 1350, trenchDepth: 2, disposalArisings: 4.43, backfill: 0 },
  { pipeDiameter: 1350, trenchDepth: 2.25, disposalArisings: 5.03, backfill: 0.4 },
  { pipeDiameter: 1350, trenchDepth: 2.5, disposalArisings: 5.64, backfill: 1 },
  { pipeDiameter: 1350, trenchDepth: 2.75, disposalArisings: 6.24, backfill: 1.61 },
  { pipeDiameter: 1350, trenchDepth: 3, disposalArisings: 6.85, backfill: 2.21 },
  { pipeDiameter: 1350, trenchDepth: 3.25, disposalArisings: 7.45, backfill: 2.82 },
  { pipeDiameter: 1350, trenchDepth: 3.5, disposalArisings: 8.06, backfill: 3.42 },
  { pipeDiameter: 1350, trenchDepth: 3.75, disposalArisings: 8.66, backfill: 4.03 },
  { pipeDiameter: 1350, trenchDepth: 4, disposalArisings: 9.27, backfill: 4.63 },
  { pipeDiameter: 1350, trenchDepth: 4.25, disposalArisings: 9.87, backfill: 5.24 },
  { pipeDiameter: 1350, trenchDepth: 4.5, disposalArisings: 10.48, backfill: 5.84 },
  { pipeDiameter: 1350, trenchDepth: 4.75, disposalArisings: 11.08, backfill: 6.45 },
  { pipeDiameter: 1350, trenchDepth: 5, disposalArisings: 11.69, backfill: 7.05 },
  { pipeDiameter: 1350, trenchDepth: 5.25, disposalArisings: 12.29, backfill: 7.66 },
  { pipeDiameter: 1350, trenchDepth: 5.5, disposalArisings: 12.9, backfill: 8.26 },
  { pipeDiameter: 1350, trenchDepth: 5.75, disposalArisings: 13.5, backfill: 8.87 },
  { pipeDiameter: 1350, trenchDepth: 6, disposalArisings: 14.11, backfill: 9.47 },
  { pipeDiameter: 1500, trenchDepth: 1, disposalArisings: 2.21, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 1.25, disposalArisings: 2.86, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 1.5, disposalArisings: 3.51, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 1.75, disposalArisings: 4.16, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 2, disposalArisings: 4.81, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 2.25, disposalArisings: 5.46, backfill: 0 },
  { pipeDiameter: 1500, trenchDepth: 2.5, disposalArisings: 6.11, backfill: 0.65 },
  { pipeDiameter: 1500, trenchDepth: 2.75, disposalArisings: 6.76, backfill: 1.3 },
  { pipeDiameter: 1500, trenchDepth: 3, disposalArisings: 7.41, backfill: 1.95 },
  { pipeDiameter: 1500, trenchDepth: 3.25, disposalArisings: 8.06, backfill: 2.6 },
  { pipeDiameter: 1500, trenchDepth: 3.5, disposalArisings: 8.71, backfill: 3.25 },
  { pipeDiameter: 1500, trenchDepth: 3.75, disposalArisings: 9.36, backfill: 3.9 },
  { pipeDiameter: 1500, trenchDepth: 4, disposalArisings: 10.01, backfill: 4.55 },
  { pipeDiameter: 1500, trenchDepth: 4.25, disposalArisings: 10.66, backfill: 5.2 },
  { pipeDiameter: 1500, trenchDepth: 4.5, disposalArisings: 11.31, backfill: 5.85 },
  { pipeDiameter: 1500, trenchDepth: 4.75, disposalArisings: 11.96, backfill: 6.5 },
  { pipeDiameter: 1500, trenchDepth: 5, disposalArisings: 12.61, backfill: 7.15 },
  { pipeDiameter: 1500, trenchDepth: 5.25, disposalArisings: 13.26, backfill: 7.8 },
  { pipeDiameter: 1500, trenchDepth: 5.5, disposalArisings: 13.91, backfill: 8.45 },
  { pipeDiameter: 1500, trenchDepth: 5.75, disposalArisings: 14.56, backfill: 9.1 },
  { pipeDiameter: 1500, trenchDepth: 6, disposalArisings: 15.21, backfill: 9.75 },
  { pipeDiameter: 1800, trenchDepth: 1, disposalArisings: 2.53, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 1.25, disposalArisings: 3.27, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 1.5, disposalArisings: 4, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 1.75, disposalArisings: 4.73, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 2, disposalArisings: 5.46, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 2.25, disposalArisings: 6.2, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 2.5, disposalArisings: 6.93, backfill: 0 },
  { pipeDiameter: 1800, trenchDepth: 2.75, disposalArisings: 7.66, backfill: 0.54 },
  { pipeDiameter: 1800, trenchDepth: 3, disposalArisings: 8.39, backfill: 1.27 },
  { pipeDiameter: 1800, trenchDepth: 3.25, disposalArisings: 9.13, backfill: 2.01 },
  { pipeDiameter: 1800, trenchDepth: 3.5, disposalArisings: 9.86, backfill: 2.74 },
  { pipeDiameter: 1800, trenchDepth: 3.75, disposalArisings: 10.59, backfill: 3.47 },
  { pipeDiameter: 1800, trenchDepth: 4, disposalArisings: 11.32, backfill: 4.2 },
  { pipeDiameter: 1800, trenchDepth: 4.25, disposalArisings: 12.06, backfill: 4.94 },
  { pipeDiameter: 1800, trenchDepth: 4.5, disposalArisings: 12.79, backfill: 5.67 },
  { pipeDiameter: 1800, trenchDepth: 4.75, disposalArisings: 13.52, backfill: 6.4 },
  { pipeDiameter: 1800, trenchDepth: 5, disposalArisings: 14.25, backfill: 7.13 },
  { pipeDiameter: 1800, trenchDepth: 5.25, disposalArisings: 14.99, backfill: 7.87 },
  { pipeDiameter: 1800, trenchDepth: 5.5, disposalArisings: 15.72, backfill: 8.6 },
  { pipeDiameter: 1800, trenchDepth: 5.75, disposalArisings: 16.45, backfill: 9.33 },
  { pipeDiameter: 1800, trenchDepth: 6, disposalArisings: 17.18, backfill: 10.06 },
  { pipeDiameter: 2100, trenchDepth: 1, disposalArisings: 2.87, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 1.25, disposalArisings: 3.68, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 1.5, disposalArisings: 4.5, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 1.75, disposalArisings: 5.31, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 2, disposalArisings: 6.13, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 2.25, disposalArisings: 6.94, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 2.5, disposalArisings: 7.76, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 2.75, disposalArisings: 8.57, backfill: 0 },
  { pipeDiameter: 2100, trenchDepth: 3, disposalArisings: 9.39, backfill: 0.39 },
  { pipeDiameter: 2100, trenchDepth: 3.25, disposalArisings: 10.2, backfill: 1.21 },
  { pipeDiameter: 2100, trenchDepth: 3.5, disposalArisings: 11.02, backfill: 2.02 },
  { pipeDiameter: 2100, trenchDepth: 3.75, disposalArisings: 11.83, backfill: 2.84 },
  { pipeDiameter: 2100, trenchDepth: 4, disposalArisings: 12.65, backfill: 3.65 },
  { pipeDiameter: 2100, trenchDepth: 4.25, disposalArisings: 13.46, backfill: 4.47 },
  { pipeDiameter: 2100, trenchDepth: 4.5, disposalArisings: 14.28, backfill: 5.28 },
  { pipeDiameter: 2100, trenchDepth: 4.75, disposalArisings: 15.09, backfill: 6.1 },
  { pipeDiameter: 2100, trenchDepth: 5, disposalArisings: 15.91, backfill: 6.91 },
  { pipeDiameter: 2100, trenchDepth: 5.25, disposalArisings: 16.72, backfill: 7.73 },
  { pipeDiameter: 2100, trenchDepth: 5.5, disposalArisings: 17.54, backfill: 8.54 },
  { pipeDiameter: 2100, trenchDepth: 5.75, disposalArisings: 18.35, backfill: 9.36 },
  { pipeDiameter: 2100, trenchDepth: 6, disposalArisings: 19.17, backfill: 10.17 },
  { pipeDiameter: 2400, trenchDepth: 1, disposalArisings: 3.16, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 1.25, disposalArisings: 4.05, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 1.5, disposalArisings: 4.94, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 1.75, disposalArisings: 5.84, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 2, disposalArisings: 6.73, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 2.25, disposalArisings: 7.62, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 2.5, disposalArisings: 8.51, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 2.75, disposalArisings: 9.41, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 3, disposalArisings: 10.3, backfill: 0 },
  { pipeDiameter: 2400, trenchDepth: 3.25, disposalArisings: 11.19, backfill: 0.23 },
  { pipeDiameter: 2400, trenchDepth: 3.5, disposalArisings: 12.08, backfill: 1.12 },
  { pipeDiameter: 2400, trenchDepth: 3.75, disposalArisings: 12.98, backfill: 2.02 },
  { pipeDiameter: 2400, trenchDepth: 4, disposalArisings: 13.87, backfill: 2.91 },
  { pipeDiameter: 2400, trenchDepth: 4.25, disposalArisings: 14.76, backfill: 3.8 },
  { pipeDiameter: 2400, trenchDepth: 4.5, disposalArisings: 15.65, backfill: 4.69 },
  { pipeDiameter: 2400, trenchDepth: 4.75, disposalArisings: 16.55, backfill: 5.59 },
  { pipeDiameter: 2400, trenchDepth: 5, disposalArisings: 17.44, backfill: 6.48 },
  { pipeDiameter: 2400, trenchDepth: 5.25, disposalArisings: 18.33, backfill: 7.37 },
  { pipeDiameter: 2400, trenchDepth: 5.5, disposalArisings: 19.22, backfill: 8.26 },
  { pipeDiameter: 2400, trenchDepth: 5.75, disposalArisings: 20.12, backfill: 9.16 },
  { pipeDiameter: 2400, trenchDepth: 6, disposalArisings: 21.01, backfill: 10.05 },
  { pipeDiameter: 2400, trenchDepth: 6.25, disposalArisings: 21.9, backfill: 10.94 },
  { pipeDiameter: 2400, trenchDepth: 6.5, disposalArisings: 22.79, backfill: 11.83 },
  { pipeDiameter: 2400, trenchDepth: 6.75, disposalArisings: 23.69, backfill: 12.73 },
  { pipeDiameter: 2400, trenchDepth: 7, disposalArisings: 24.58, backfill: 13.62 },
];

const sewerRateIndex = new Map<string, SewerRateEntry>(
  SEWER_RATES.map((e) => [`${e.pipeDiameter}|${e.trenchDepth.toFixed(2)}`, e]),
);

/** Exact-match lookup mirroring the source XLOOKUP(...,0) — no match returns 0 for both fields. */
export const findSewerRate = (
  pipeDiameterMm: number,
  trenchDepth: number,
): { disposalArisings: number; backfill: number } => {
  const entry = sewerRateIndex.get(`${pipeDiameterMm}|${trenchDepth.toFixed(2)}`);
  return entry
    ? { disposalArisings: entry.disposalArisings, backfill: entry.backfill }
    : { disposalArisings: 0, backfill: 0 };
};
